"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.alterDate = void 0;
const get_today_date_1 = require("../get-today-date/get-today-date");
/**
 * Alter a date object by adding/substracting days/months/years
 * @public
 *
 * @param args - The arguments to operate in this function, if no date is passed then {@link getTodayDate} is used as default date
 *
 * @returns A new date with the operations applied
 *
 * @example
 * ```ts
 * const result = alterDate({
 *  date: new Date(2021, 1, 1),
 * days: 365,
 * });
 * console.log(result);
 * // -> Tue Feb 01 2022 00:00:00 GMT+0100 (Central European Standard Time)
 * ```
 */
function alterDate({ date, days = 0, months = 0, years = 0, } = {}) {
    const newDate = date instanceof Date ? new Date(date.getTime()) : (0, get_today_date_1.getTodayDate)();
    if (days) {
        newDate.setDate(newDate.getDate() + days);
    }
    if (months) {
        newDate.setMonth(newDate.getMonth() + months);
    }
    if (years) {
        newDate.setFullYear(newDate.getFullYear() + years);
    }
    return newDate;
}
exports.alterDate = alterDate;
//# sourceMappingURL=alter-date.js.map